import { createStore, combineReducers, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import miusuario from '../redux/reducers/miusuario'
import pais from '../redux/reducers/pais'
import idioma from '../redux/reducers/idioma'
import notificaciones from '../redux/reducers/notificaciones'
import interfaz from '../redux/reducers/interfaz'
import empresa from '../redux/reducers/empresa'
import esquema_tablas from '../redux/reducers/esquema'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
 
const thunkMiddleware = require('redux-thunk').default

const rootReducer = combineReducers({
    esquema_tablas,
    miusuario,
    interfaz,
    notificaciones,
    idioma,
    pais,
    empresa
})

const persistConfig = {
  key: 'root',
  storage,
}
 
const persistedReducer = persistReducer(persistConfig, rootReducer)
 
const empaquetar = () => {
  let store = createStore(persistedReducer, applyMiddleware(thunkMiddleware))
  let persistor = persistStore(store)
  return { store, persistor }
}

export default empaquetar